import React from 'react';
import { Router, Route, browserHistory, createMemoryHistory } from 'react-router';
import { createMemoryHistory as createMemoryHistoryRouterV4 } from 'history';
import { formatUrl } from 'url-lib';
/**
 * Provides an environment appropriate history management object for react-router
 */

export var getHistory = function getHistory() {
  var routerConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var hasBrowserHistory = typeof browserHistory !== 'undefined' && process.env.NODE_ENV !== 'test';

  var _browserHistory;

  if (hasBrowserHistory) {
    _browserHistory = browserHistory;
  } else if (routerConfig.isRouterV4) {
    _browserHistory = createMemoryHistoryRouterV4();
  } else {
    _browserHistory = createMemoryHistory();
  }

  return _browserHistory;
};
/**
 * Replaces the specified history object with the specified request parameters
 * (particularly useful for initial server rendering)
 * @param {import("history").History} routerHistory The history object
 * @param {{path: string, params: object}} params
 */

export var updateHistory = function updateHistory(routerHistory, _ref) {
  var path = _ref.path,
      params = _ref.params;
  routerHistory.replace(formatUrl(path, params));
};
/**
 * Some functionality relies on certain router elements being present
 * in context.  This shim creates a very thin set of router/route elements
 * so that all necessary requirements are fulfilled.
 * @param {object} props - render prop that returns JSX descendants who rely on router elements
 */

export var RouterShim = function RouterShim(_ref2) {
  var render = _ref2.render;

  var _renderChild = function _renderChild(routeProps) {
    return render(routeProps);
  };

  return React.createElement(Router, {
    history: createMemoryHistory(),
    children: React.createElement(Route, {
      path: '/',
      component: _renderChild
    })
  });
};